import {CounterpartStatus} from '../../../claims/claims-commons/models/counterparty.model';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {InnerMessage, InnerMessagesService} from '../../service/inner-messages.service';
import {Subscription} from 'rxjs/Subscription';
import {animate, state, style, transition, trigger} from '@angular/animations';
import $ from 'jquery/dist/jquery.min.js';
import {Utilities} from '../../utilities/utilities.model';
import {ClaimsStatus, ComunicationType} from '../../../claims/claims-commons/models/claim.model';
import {ClaimsMessagesCode} from '../../../claims/claims-commons/models/error-response.model';
import {LogisticsErrorCode} from '../../../logistics/models/error-response.model';
import {TranslateContext} from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-inner-messages',
	templateUrl: './inner-messages.component.html',
	styleUrls: ['./inner-messages.component.scss'],
	animations: [
		trigger('visibilityChanged', [
			state('shown', style({opacity: 1, visibility: 'visible'})),
			state('hidden', style({opacity: 0, height: '0px', visibility: 'hidden'})),
			transition('* => *', animate('300ms')),
		])
	]
})
export class InnerMessagesComponent implements OnInit, OnDestroy {
	flottaPoolTranslateContext: TranslateContext = TranslateContext.FLOTTA_POOL;
	sharedTranslateContext: TranslateContext = TranslateContext.SHARED;
	LogisticsTranslateContext: TranslateContext = TranslateContext.LOGISTICS;
	authority_t: TranslateContext = TranslateContext.AUTHORITY;


	// TODO
	// questo elenco (inutile) andrebbe messo in un altro file
	invoicingReferenceOk = InnerMessage.INVOICING_REFERENCE_OK;
	orderDoesNotBelongToThisCenter = InnerMessage.ORDER_DOES_NOT_BELONG_TO_THIS_CENTER;
	changedPasswordOK = InnerMessage.CHANGED_PASSWORD_OK;
	changedPasswordKO = InnerMessage.CHANGED_PASSWORD_KO;
	sentAlertOK = InnerMessage.SENT_ALERT_OK;
	sentAlertOKButAttachmentsKO = InnerMessage.SENT_ALERT_OK_BUT_ATTACHMENTS_KO;
	sentAlertKO = InnerMessage.SENT_ALERT_KO;
	sentAlertWithAttachmentsKO = InnerMessage.SENT_ALERT_WITH_ATTACHMENTS_KO;
	allAlertUpdatedKO = InnerMessage.ALL_ALERT_UPDATED_KO;
	genericError = InnerMessage.GENERIC_ERROR;
	orderNotExist = InnerMessage.ORDER_NOT_EXIST;
	sentReportingOK = InnerMessage.SENT_REPORTING_OK;
	sentReportingKO = InnerMessage.SENT_REPORTING_KO;
	sentSuspendReadyOK = InnerMessage.SENT_SUSPEND_READY_OK;
	sentSuspendReadyKO = InnerMessage.SENT_SUSPEND_READY_KO;
	sentReadyOK = InnerMessage.SENT_READY_OK;
	sentReadyKO = InnerMessage.SENT_READY_KO;
	sentAcceptOrderOK = InnerMessage.SENT_ACCEPT_ORDER_OK;
	sentAcceptOrderKO = InnerMessage.SENT_ACCEPT_ORDER_KO;
	sentDeclineOrderOK = InnerMessage.SENT_DECLINE_ORDER_OK;
	searchOrderResultVoid = InnerMessage.SEARCH_ORDER_RESULT_VOID;
	searchInvoiceResultVoid = InnerMessage.SEARCH_INVOICE_RESULT_VOID;
	searchTaskResultVoid = InnerMessage.SEARCH_TASK_RESULT_VOID;
	searchAlertResultVoid = InnerMessage.SEARCH_ALERT_RESULT_VOID;
	serverError = InnerMessage.SERVER_ERROR;
	orderOrAlertDoesNotBelongToThisCenter = InnerMessage.ORDER_OR_ALERT_DOES_NOT_BELONG_TO_THIS_CENTER;
	orderDeliverySavedButNotValid = InnerMessage.ORDER_DELIVERY_SAVED_BUT_NOT_VALID;
	fileAttachedSaveOK = InnerMessage.FILE_ATTACHED_SAVED_OK;
	fileAttachedSaveKO = InnerMessage.FILE_ATTACHED_SAVED_KO;
	fileAttachedRemoveOK = InnerMessage.FILE_ATTACHED_REMOVED_OK;
	fileAttachedRemoveKO = InnerMessage.FILE_ATTACHED_REMOVED_KO;
	fileDownloadKO = InnerMessage.FILE_DOWNLOAD_KO;
	fileNotFound = InnerMessage.FILE_NOT_FOUND;
	fileExportOK = InnerMessage.FILE_EXPORT_OK;
	ordersDetailsCertificateAttachedSavedOK = InnerMessage.ORDERS_DETAILS_CERTIFICATE_ATTACHED_SAVED_OK;
	ordersDetailsCertificateAttachedSavedKO = InnerMessage.ORDERS_DETAILS_CERTIFICATE_ATTACHED_SAVED_KO;


	orderDeliveryDriverDocumentsMissing = InnerMessage.ORDER_DELIVERY_DRIVER_DOCUMENTS_MISSING;
	orderDeliveryDelegateDocumentsMissing = InnerMessage.ORDER_DELIVERY_DELEGATE_DOCUMENTS_MISSING;

	orderADCGenerateKO = InnerMessage.ORDER_ADC_GENERATE_KO;

	orderLetterGenerateOK = InnerMessage.ORDER_LETTER_GENERATE_OK;
	orderLetterGenerateKO = InnerMessage.ORDER_LETTER_GENERATE_KO;

	// DIGITAL SIGNATURE MESSAGE
	digitalSignGenericError = InnerMessage.DIGITAL_SIGN_GENERIC_ERROR;
	digitalSignWrongOtpOrPin = InnerMessage.DIGITAL_SIGN_WRONG_OTP_OR_PIN;
	digitalSignStatusNotValid = InnerMessage.DIGITAL_SIGN_STATUS_NOT_VALID;
	digitalSignAbortOK = InnerMessage.DIGITAL_SIGN_ABORT_OK;
	digitalSignStatusError = InnerMessage.DIGITAL_SIGN_STATUS_ERROR;

	digitalSignProcessCompetedOK = InnerMessage.DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK;
	digitalSignProcessCompetedKO = InnerMessage.DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_KO;
	digitalSignProcessCompetedOKButStatusNotUpdated = InnerMessage.DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK_BUT_STATUS_NOT_UPDATED;
	digitalSignProcessCompetedOKButFEGenericError = InnerMessage.DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK_BUT_FE_GENERIC_ERROR;
	digitalSignProcessCompetedOKButUnknowType = InnerMessage.DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK_BUT_UNKNOW_TYPE;
	digitalSignProcessCompetedOKButVoidSignResponse = InnerMessage.DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK_BUT_VOID_SIGN_RESPONSE;
	digitalSignProcessCompetedOKButDSError = InnerMessage.DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK_BUT_DS_ERROR;
	digitalSignProcessCompetedOKButWDError = InnerMessage.DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK_BUT_WD_ERROR;
	digitalSignProcessCompetedOKButFMError = InnerMessage.DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK_BUT_FM_ERROR;
	digitalSignProcessCompetedOKButAcceptError = InnerMessage.DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK_BUT_ACCEPT_ERROR;
	digitalSignAndAcceptProcessGenericKO = InnerMessage.DIGITAL_SIGN_SIGN_AND_ACCEPT_PROCESS_GENERIC_KO;


	appointmentUpdateOK = InnerMessage.APPOINTMENT_UPDATE_OK;
	appointmentUpdateKO = InnerMessage.APPOINTMENT_UPDATE_KO;
	appointmentDkcUpdateOK = InnerMessage.APPOINTMENT_DKC_UPDATE_OK;
	appointmentDkcUpdateKO = InnerMessage.APPOINTMENT_DKC_UPDATE_KO;
	appointmentDkcUpdateOKsmsKO = InnerMessage.APPOINTMENT_DKC_UPDATE_OK_SMS_KO;
	appointmentDkcUpdateOKsmsKOemailKO = InnerMessage.APPOINTMENT_DKC_UPDATE_OK_SMS_KO_EMAIL_KO;
	appointmentDkcUpdateOKsmsOKemailKO = InnerMessage.APPOINTMENT_DKC_UPDATE_OK_SMS_OK_EMAIL_KO;
	appointmentDkcUpdateOKsmsKOemailOK = InnerMessage.APPOINTMENT_DKC_UPDATE_OK_SMS_KO_EMAIL_OK;
	appointmentCreateOK = InnerMessage.APPOINTMENT_CREATE_OK;
	appointmentCreateKO = InnerMessage.APPOINTMENT_CREATE_KO;
	searchAppointmentResultVoid = InnerMessage.SEARCH_APPOINTMENT_RESULT_VOID;

	orderDetailsDeliveryError404 = InnerMessage.ORDER_DETAILS_DELIVERY_ERROR_404;

	updateTagOK = InnerMessage.UPDATE_TAG_OK;
	updateTagKO = InnerMessage.UPDATE_TAG_KO;
	updateThreadOK = InnerMessage.UPDATE_THREAD_OK;
	updateThreadKO = InnerMessage.UPDATE_THREAD_KO;
	deletedThreadOK = InnerMessage.DELETED_THREAD_OK;
	searchThreadResultVoid = InnerMessage.SEARCH_THREAD_RESULT_VOID;
	ccReportDetailsListSaveOK = InnerMessage.CC_REPORT_DETAILS_LIST_SAVE_OK;
	ccReportDetailsListSaveKO = InnerMessage.CC_REPORT_DETAILS_LIST_SAVE_KO;
	ccReportDetailsListClosedOK = InnerMessage.CC_REPORT_DETAILS_LIST_CLOSED_OK;
	ccReportDetailsListClosedKO = InnerMessage.CC_REPORT_DETAILS_LIST_CLOSED_KO;
	ccReportDetailsListDeletedOK = InnerMessage.CC_REPORT_DETAILS_LIST_DELETED_OK;
	ccReportDetailsListDeletedKO = InnerMessage.CC_REPORT_DETAILS_LIST_DELETED_KO;
	ccSearchContractsResultVoid = InnerMessage.CC_SEARCH_CONTRACT_RESULT_VOID;


	ccSpoSetContractReadyForSurveyOK = InnerMessage.CC_SPO_SET_CONTRACT_READY_FOR_SURVEY_OK;
	ccSpoSetContractReadyForSurveyKO = InnerMessage.CC_SPO_SET_CONTRACT_READY_FOR_SURVEY_KO;

	ccContractNotExist = InnerMessage.CC_CONTRACT_NOT_EXIST;

	ccSpoImportContractFromEsbOK = InnerMessage.CC_SPO_IMPORT_CONTRACT_FROM_ESB_OK;
	ccSpoImportContractFromEsbOKButAppointmentNotConfirmed = InnerMessage.CC_SPO_IMPORT_CONTRACT_FROM_ESB_OK_BUT_APPOINTMENT_NOT_CONFIRMED;
	ccSpoImportContractFromEsbKO = InnerMessage.CC_SPO_IMPORT_CONTRACT_FROM_ESB_KO;

	ccSpoContractStatusNotValidForSurvey = InnerMessage.CC_CONTRACT_STATUS_NOT_VALID_FOR_SURVEY;

	ccReportDetailsInvalidListExternalDamages = InnerMessage.CC_REPORT_DETAILS_INVALID_LIST_EXTERNAL_DAMAGES;
	ccReportDetailsInvalidListInternalDamages = InnerMessage.CC_REPORT_DETAILS_INVALID_LIST_INTERNAL_DAMAGES;
	ccReportDetailsInvalidSurveyNotes = InnerMessage.CC_REPORT_DETAILS_INVALID_SURVEY_NOTES;
	ccReportDetailsInvalidTireConditions = InnerMessage.CC_REPORT_DETAILS_INVALID_TIRE_CONDITIONS;

	ccSpoSaveCustomerOK = InnerMessage.CC_SPO_SAVE_CUSTOMER_OK;
	ccSpoSaveCustomerKO = InnerMessage.CC_SPO_SAVE_CUSTOMER_KO;
	ccSpoSaveCustomerOKButNotValid = InnerMessage.CC_SPO_SAVE_CUSTOMER_OK_BUT_NOT_VALID;
	ccSpoDocumentMissing = InnerMessage.CC_SPO_DOCUMENT_MISSING;
	ccSpoCertificateGenerateKO = InnerMessage.CC_SPO_CERTIFICATE_GENERATE_KO;

	ccImportContractFromEsbOK = InnerMessage.CC_IMPORT_CONTRACT_FROM_ESB_KO;

	ccSpoCertificateAttachedOK = InnerMessage.CC_SPO_CERTIFICATE_ATTACHED_OK;
	ccSpoCertificateAttachedKO = InnerMessage.CC_SPO_CERTIFICATE_ATTACHED_KO;

	ccSpoContractDeclinedOK = InnerMessage.CC_SPO_CONTRACT_DECLINED_OK;
	ccSpoContractDeclinedKO = InnerMessage.CC_SPO_CONTRACT_DECLINED_KO;
	ccSpoContractIsWithoutSurvey = InnerMessage.CC_SPO_CONTRACT_IS_WITHOUT_SURVEY;

	ccAldImportContractOK = InnerMessage.CC_ALD_IMPORT_CONTRACTS_OK;
	ccAldImportContractKO = InnerMessage.CC_ALD_IMPORT_CONTRACTS_KO;
	ccAldImportContractKOMaxNum= InnerMessage.CC_ALD_IMPORT_CONTRACTS_KO_MAX_NUM

	ccAldClosedContractOK = InnerMessage.CC_ALD_CLOSED_CONTRACTS_OK;
	ccAldClosedContractOKButNotAll = InnerMessage.CC_ALD_CLOSED_CONTRACTS_OK_BUT_NOT_ALL;
	ccAldClosedContractKO = InnerMessage.CC_ALD_CLOSED_CONTRACTS_KO;

	ccAldImportContractsErrorConvertTOBase64 = InnerMessage.CC_ALD_IMPORT_CONTRACTS_ERROR_CONVERT_TO_BASE64;

	ccSpoContractNDSCloseOK = InnerMessage.CC_SPO_CONTRACT_NDS_CLOSED_OK;
	ccSpoContractNDSCloseKO = InnerMessage.CC_SPO_CONTRACT_NDS_CLOSED_KO;

	CC_SUCCESS_GENERAL_NOTE_CREATED = InnerMessage.CC_SUCCESS_GENERAL_NOTE_CREATED;
	CC_GENERAL_OPERATION_SUCCESS = InnerMessage.CC_GENERAL_OPERATION_SUCCESS;

	ccDkcSurveyorSearchResultVoid = InnerMessage.CC_DKC_SURVEYOR_SEARCH_RESULT_VOID;
	ccDkcSurveyorCreateOK = InnerMessage.CC_DKC_SURVEYOR_CREATE_OK;
	ccDkcSurveyorCreateOKButNotAssociateProfile = InnerMessage.CC_DKC_SURVEYOR_CREATE_OK_BUT_NOT_ASSOCIATE_PROFILE;
	ccDkcSurveyorCreateOKButNotAssociateCross = InnerMessage.CC_DKC_SURVEYOR_CREATE_OK_BUT_NOT_ASSOCIATE_CROSS;
	ccDkcSurveyorCreateOKButNotAssociateModule = InnerMessage.CC_DKC_SURVEYOR_CREATE_OK_BUT_NOT_ASSOCIATE_MODULE;
	ccDkcSurveyorCreateGeneralKO = InnerMessage.CC_DKC_SURVEYOR_CREATE_GENERAL_KO;
	ccDkcSurveyorCreateUserAlreadyExitKO = InnerMessage.CC_DKC_SURVEYOR_CREATE_USER_ALREADY_EXIST_KO;
	ccDkcSurveyorUpdateUserOK = InnerMessage.CC_DKC_SURVEYOR_UPDATE_USER_OK;
	ccDkcSurveyorUpdateUserKO = InnerMessage.CC_DKC_SURVEYOR_UPDATE_USER_KO;

	CCDkBoContractDetailsNoValidData = InnerMessage.CC_DK_BO_CONTRACT_DETAIL_NOVALIDDATA;
	CCDkBoContractDetailsClaimsError = InnerMessage.CC_DK_BO_CONTRACT_DETAIL_CLAIMS_ERROR;
	CCDkBoContractCurrencyNoValidData = InnerMessage.CC_DK_BO_CONTRACT_CURRENCY_NOVALIDDATA;
	CCDkBoLetterGenerateKo = InnerMessage.CC_DK_BO_LETTER_GENERATE_KO;
	CCDkBoLetterGenerateOk = InnerMessage.CC_DK_BO_LETTER_GENERATE_OK;

	ccDkcCommodityNotFound = InnerMessage.CC_DKC_COMMODITY_NOTFOUND;
	ccDkcContractAlreadyImported = InnerMessage.CC_DKC_CONTRACT_ALREADY_IMPORTED;
	ccDkoSurveyAccessoriesKO = InnerMessage.CC_DKO_SURVEYOR_ACCESSORIES_KO;
	ucCreateAppointmentKo = InnerMessage.UC_CREATE_APPOINTMENT_KO;
	UcProcedureLoadError = InnerMessage.UC_PROCEDURE_LOAD_ERROR;
	UcPaperSignatureUploadOk = InnerMessage.UC_PAPER_SIGNATURE_UPLOAD_OK;

	claimsErrorCode = ClaimsMessagesCode;
	claimStatus = ClaimsStatus;
	claimImportFileKo = InnerMessage.CLAIMS_IMPORT_FILE_KO;
	claimImportFileOk = InnerMessage.CLAIMS_IMPORT_FILE_OK;
	claimsSearchAppropriationResultVoid = InnerMessage.CLAIMS_SEARCH_APPROPRIATION_RESULT_VOID;
	claimsAppropriationAlreadySequestered = InnerMessage.CLAIMS_APPROPRIATION_ALREADY_SEQUESTERED;
	claimsAppropriationCreateOK = InnerMessage.CLAIMS_APPROPRIATION_CREATE_OK;
	claimsAppropriationCreateKO = InnerMessage.CLAIMS_APPROPRIATION_CREATE_KO;
	claimsAppropriationClaimNotFound = InnerMessage.CLAIMS_APPROPRIATION_CLAIM_NOT_FOUND;
	claimsAppropriationFilesAddOK = InnerMessage.CLAIMS_APPROPRIATION_FILES_ADD_OK;


	claimsPracticeCarCreatedOK = InnerMessage.CLAIMS_PRACTICE_CAR_CREATE_OK;
	claimsPracticeCarResultVoid = InnerMessage.CLAIMS_SEARCH_PRACTICE_CAR_RESULT_VOID;


	claimsAppropriationPracticeCarPlateNotFound = InnerMessage.CLAIMS_APPROPRIATION_PRACTICE_CAR_PLATE_NOT_FOUND;
	claimsAppropriationPracticeCarChangeStatusOK = InnerMessage.CLAIMS_APPROPRIATION_PRACTICE_CAR_PLATE_CHANGE_STATUS_OK;
	claimsAppropriationPracticeCarDeleteFileOK = InnerMessage.CLAIMS_APPROPRIATION_PRACTICE_CAR_DELETE_FILE_OK;
	claimsAppropriationPracticeCarDeleteFileKO = InnerMessage.CLAIMS_APPROPRIATION_PRACTICE_CAR_DELETE_FILE_KO;
	claimsEntityAlreadyEnabled = InnerMessage.CLAIMS_ENTITY_ALREADY_ENABLED;
	claimsComunicationSuccess = InnerMessage.CLAIMS_COMUNICATION_SUCCESS;

	counterpartyStatus = CounterpartStatus;
	repairSuffix: string = InnerMessage.REPAIR_SUFFIX;
	claimSearchClaimsResultVoid = InnerMessage.CLAIMS_SEARCH_CLAIMS_RESULT_VOID;
	claimSearchCounterpartyResultVoid = InnerMessage.CLAIMS_SEARCH_COUNTERPARTY_RESULT_VOID;
	claimsDraftCreated = InnerMessage.CLAIMS_DRAFT_CREATED;
	claimsDraftUpdated = InnerMessage.CLAIMS_DRAFT_UPDATED;
	claimsCreated = InnerMessage.CLAIMS_CREATED;
	claimsUpdated = InnerMessage.CLAIMS_UPDATED;
	claimsEntityCreated = InnerMessage.CLAIMS_ENTITY_CREATED;
	claimsEntityUpdated = InnerMessage.CLAIMS_ENTITY_UPDATED;
	claimsEntityEnabled = InnerMessage.CLAIMS_ENTITY_ENABLED;
	claimsEntityDisabled = InnerMessage.CLAIMS_ENTITY_DISABLED;
	claimsEntityDeleted = InnerMessage.CLAIMS_ENTITY_DELETED;
	claimsGenericError = InnerMessage.CLAIMS_GENERIC_ERROR;
	claimsGenericResultVoid = InnerMessage.CLAIMS_GENERIC_RESULT_VOID;
	claimCustomerStatusUpdated = InnerMessage.CLAIMS_CUSTOMER_STATUS_UPDATED;
	claimsAuthorityLinkEnabled = InnerMessage.CLAIMS_AUTHORITY_LINK_ENABLED;
	claimsAuthorityLinkDisabled = InnerMessage.CLAIMS_AUTHORITY_LINK_DISABLED;
	claimsExportClaims = InnerMessage.CLAIMS_EXPORT_CLAIMS;
	claimsExportThefts = InnerMessage.CLAIMS_EXPORT_THEFTS;
	claimsComunicationType= ComunicationType;

	isBlacklistCustomer = InnerMessage.BLACK_CUSTOMER;

	voidEmailList = InnerMessage.VOID_EMAIL_LIST;

    MAX_MES = 1;
    searchMovementsResultVoid = InnerMessage.SEARCH_MOVEMENTS_RESULT_VOID;
    tyreCodePlateNotFound = InnerMessage.TYRE_CODE_PLATE_NOT_FOUND;
    tyreRequestSuccessfullyTaken = InnerMessage.TYRE_REQUEST_SUCCESSFULLY_TAKEN;
    tyreRequestSuccessfullyCompleted = InnerMessage.TYRE_REQUEST_SUCCESSFULLY_COMPLETED;
    tyreTransferSuccessfullyAccepted = InnerMessage.TYRE_TRANSFER_SUCCESSFULLY_ACCEPTED;
    tyreTransferLockedAldInstruction = InnerMessage.TYRE_TRANSFER_LOCKED_ALD_INSTRUCTION;
    tyreTransferReject = InnerMessage.TYRE_TRANSFER_REJECT;
    tyreSuccessfullyRegistered = InnerMessage.TYRE_SUCCESSFULLY_REGISTERED;
    tyreSuccessfullyReject = InnerMessage.TYRE_SUCCESSFULLY_REJECT;
    tyreErrorDownloadDDT = InnerMessage.TYRE_ERROR_DOWNLOAD_DDT;
    tyreErrorDownloadCustomerRelease = InnerMessage.TYRE_ERROR_DOWNLOAD_CUSTOMER_RELEASE;
    tyreErrorDownloadLabel = InnerMessage.TYRE_ERROR_DOWNLOAD_LABEL;
    tyreErrorDeliveryTyreIncomplete = InnerMessage.TYRE_ERROR_DELIVERY_TYRE_INCOMPLETE;
    tyreErrorUnlock = InnerMessage.TYRE_ERROR_UNLOCK;
    tyreSuccessUnlock = InnerMessage.TYRE_SUCCESS_UNLOCK;
    tyreErrorForceClose = InnerMessage.TYRE_ERROR_FORCE_CLOSE;
    tyreSuccessForceClose = InnerMessage.TYRE_SUCCESS_FORCE_CLOSE;
    tyreErrorWithdrawn = InnerMessage.TYRE_ERROR_WITHDRAWN;
    tyreSuccessWithdrawn = InnerMessage.TYRE_SUCCESS_WITHDRAWN;
    tyreDeliveryLate = InnerMessage.TYRE_DELIVERY_LATE;
    tyreExpiring = InnerMessage.TYRE_EXPIRING;
    tyreDisposed: string = InnerMessage.TYRE_DISPOSED;
    tyresDisposed: string = InnerMessage.TYRES_DISPOSED;

	searchLogisticTransferResultVoid = InnerMessage.SEARCH_LOGISTIC_TRANSFER_RESULT_VOID;
	searchLogisticSegmentResultVoid = InnerMessage.SEARCH_LOGISTIC_SEGMENT_RESULT_VOID;
	searchLogisticChannelResultVoid = InnerMessage.SEARCH_LOGISTIC_CHANNEL_RESULT_VOID;
	searchLogisticTransporterResultVoid = InnerMessage.SEARCH_LOGISTIC_TRANSPORTER_RESULT_VOID;
	searchLogisticRulesResultVoid: string = InnerMessage.SEARCH_LOGISTIC_RULES_RESULT_VOID;
	searchLogisticSaturationResultVoid: string = InnerMessage.SEARCH_LOGISTIC_SATURATION_RESULT_VOID;
	searchLogisticRequestResultVoid: string = InnerMessage.SEARCH_LOGISTIC_REQUEST_RESULT_VOID;
	logisticTransferWithdrawalFailure = InnerMessage.LOGISTIC_TRANSFER_WITHDRAWAL_FAILURE;
	logisticTransferDeliveryFailure = InnerMessage.LOGISTIC_TRANSFER_DELIVERY_FAILURE;
	logisticTransferRefused = InnerMessage.LOGISTIC_TRANSFER_REFUSED;
	logisticTransferRefusedChannelFornitoreIntegrato = InnerMessage.LOGISTIC_TRANSFER_REFUSED_CHANNEL_FORNITORE_INTEGRATO;
	logisticVehicleNotFound = InnerMessage.LOGISTIC_VEHICLE_NOT_FOUND;
	logisticAdminPenaltiesSuccesfulSent = InnerMessage.LOGISTIC_ADMIN_PENALTIES_SUCCESSFUL_SENT;
	logisticsErrorCode: any = LogisticsErrorCode;
	logisticsAssignmentKO: string = InnerMessage.LOGISTIC_ASSIGNMENT_ERROR;
	logisticsAssignmentOK: string = InnerMessage.LOGISTIC_ASSIGNMENT_SUCCESS;
	logisticsAssignmentDeliveryError: string = InnerMessage.LOGISTIC_ASSIGNMENT_DELIVERY_ERROR;
	logisticsDDTVoid: string = InnerMessage.LOGISTIC_DDT_VOID;
	searchLogisticsAsrVoid: string = InnerMessage.SEARCH_LOGISTIC_ASR_VOID;
	searchLogisticsAsrServiceVoid: string = InnerMessage.SEARCH_LOGISTIC_ASR_SERVICE_VOID;
	searchLogisticAsrVehicleEntryResultVoid: string = InnerMessage.SEARCH_LOGISTIC_ASR_VEHICLE_ENTRY_RESULT_VOID;
	searchLogisticAsrVehicleCheckoutResultVoid: string = InnerMessage.SEARCH_LOGISTIC_ASR_VEHICLE_CHECKOUT_RESULT_VOID;
	searchLogisticAsrVehicleStockResultVoid: string = InnerMessage.SEARCH_LOGISTIC_ASR_VEHICLE_STOCK_RESULT_VOID;
	searchLogisticAsrVehicleDeliveredResultVoid: string = InnerMessage.SEARCH_LOGISTIC_ASR_VEHICLE_DELIVERED_RESULT_VOID;
	logisticImportError: string = InnerMessage.LOGISTIC_IMPORT_ERROR;
	logisticImportSuccess: string = InnerMessage.LOGISTIC_IMPORT_SUCCESS;
	logisticExportSuccess: string = InnerMessage.LOGISTIC_EXPORT_SUCCESS;



	ucDamagesKO = InnerMessage.UC_DAMAGES_KO;

	searchContractResultVoid = InnerMessage.SEARCH_CONTRACT_RESULT_VOID;
	searchTyresResultVoid = InnerMessage.SEARCH_TYRES_RESULT_VOID;

	innerMessages: Map<string, InnerMessage>;
	subPushInnerMessageService: Subscription;
	subRemoveInnerMessageService: Subscription;
	innerMessagesValues: InnerMessage[];

	authorityNotSaved = InnerMessage.AUTHORITY_NOT_SAVED;
	authoritySaved = InnerMessage.AUTHORITY_SAVED;
	authorityQuotationNotSaved = InnerMessage.AUTHORITY_QUOTATION_NOT_SAVED;
	authorityQuotationSaved = InnerMessage.AUTHORITY_QUOTATION_SAVED;
	authorityContractNotActive = InnerMessage.AUTHORITY_CONTRACT_NOT_ACTIVE;
	authorityOperationSaved = InnerMessage.AUTHORITY_OPERATION_SAVED;
	authorityCarglassAuthorized = InnerMessage.AUTHORITY_CARGLASS_AUTHORIZED;
	authorityCarglassRejected = InnerMessage.AUTHORITY_CARGLASS_REJECTED;
	authorityCarglassClaimsLinked = InnerMessage.AUTHORITY_CARGLASS_CLAIMS_LINKED;
	authorityWarrantyUpdated = InnerMessage.AUTHORITY_WARRANTY_UPDATED;
	authoritySuccessImport = InnerMessage.AUTHORITY_SUCCESS_IMPORT;

	searchOperationResultVoid = InnerMessage.AUTHORITY_RESULT_VOID;

	AUTHORITY_WORKING_RESULT_VOID = InnerMessage.AUTHORITY_WORKING_RESULT_VOID;
	// Authority performance
	// nessun risultato - controllare negli archivi
	AUTHORITY_DOSSIERS_RESULT_VOID_CHECK_ARCHIVE 		 = InnerMessage.AUTHORITY_DOSSIERS_RESULT_VOID_CHECK_ARCHIVE;
	AUTHORITY_WORKINGS_RESULT_VOID_CHECK_ARCHIVE 		 = InnerMessage.AUTHORITY_WORKINGS_RESULT_VOID_CHECK_ARCHIVE;
	AUTHORITY_GLASSES_RESULT_VOID_CHECK_ARCHIVE 		 = InnerMessage.AUTHORITY_GLASSES_RESULT_VOID_CHECK_ARCHIVE;
	AUTHORITY_OPERATIONS_RESULT_VOID_CHECK_ARCHIVE 	 = InnerMessage.AUTHORITY_OPERATIONS_RESULT_VOID_CHECK_ARCHIVE;
	AUTHORITY_APPOINTMENTS_RESULT_VOID_CHECK_ARCHIVE = InnerMessage.AUTHORITY_APPOINTMENTS_RESULT_VOID_CHECK_ARCHIVE;

	flottaPoolErrorStateContract = InnerMessage.FLOTTA_POOL_STATE_ERROR_CONTRACT;
	flottaPoolImportProcessStarted = InnerMessage.FLOTTA_POOL_IMPORT_PROCESS_STARTED;
	flottaPoolDoubleKeysError = InnerMessage.FLOTTA_POOL_DOUBLE_KEYS_ERROR;
	superuserGateway1002: string = InnerMessage.SUPER_USER_GATEWAY_1002;

	CHANGE_USER_1054: string = InnerMessage.CHANGE_USER_1054;
	CHANGE_USER_1055: string = InnerMessage.CHANGE_USER_1055;
	CHANGE_USER_1056: string = InnerMessage.CHANGE_USER_1056;
	CHANGE_USER_1058: string = InnerMessage.CHANGE_USER_1058;

	MIDDLEWARE_CLIENT_9013: string = InnerMessage.MIDDLEWARE_CLIENT_9013;

	successUploadedAttachment = InnerMessage.SUCCESS_UPLOADED_ATTACHMENT;
	successDeletedAttachment = InnerMessage.SUCCESS_DELETED_ATTACHMENT;
	opsCEStatoUnProblema = InnerMessage.OPS_C_E_STATO_UN_PROBLEMA;
	processato = InnerMessage.PROCESSATO;
	emailInviataCorrettamente = InnerMessage.EMAIL_INVIATA_CORRETTAMENTE;
	dataModificataCorrettamente = InnerMessage.DATA_MODIFICATA_CORRETTAMENTE;
	impossibileRecuperareIDatiDellaPratica = InnerMessage.IMPOSSIBILE_RECUPERARE_I_DATI_DELLA_PRATICA;
	modificaEffetttuataConSuccesso = InnerMessage.MODIFICA_EFFETTTUATA_CON_SUCCESSO;
	emailNonInviataCorrettamente = InnerMessage.EMAIL_NON_INVIATA_CORRETTAMENTE;
	andareInPianificazione = InnerMessage.ANDARE_IN_PIANIFICAZIONE;
	evidenzeForzate = InnerMessage.EVIDENZE_FORZATE;
	affidoForzato = InnerMessage.AFFIDO_FORZATO;
	praticheAssegnateCorrettamente = InnerMessage.PRATICHE_ASSEGNATE_CORRETTAMENTE;
	LOGISTICS_8001: string = InnerMessage.LOGISTICS_8001;
	LOGISTICS_8002: string = InnerMessage.LOGISTICS_8002;
	LOGISTICS_8003: string = InnerMessage.LOGISTICS_8003;
	LOGISTICS_8004: string = InnerMessage.LOGISTICS_8004;
	LOGISTICS_8005: string = InnerMessage.LOGISTICS_8005;
	LOGISTICS_8006: string = InnerMessage.LOGISTICS_8006;
	LOGISTICS_8007: string = InnerMessage.LOGISTICS_8007;
	LOGISTICS_8008: string = InnerMessage.LOGISTICS_8008;
	LOGISTICS_8011: string = InnerMessage.LOGISTICS_8011;

	BOOKINGS_12014: string = InnerMessage.BOOKINGS_12014;
	BOOKINGS_12015: string = InnerMessage.BOOKINGS_12015;
	BOOKINGS_12016: string = InnerMessage.BOOKINGS_12016;
	BOOKINGS_12017: string = InnerMessage.BOOKINGS_12017;	
	
	translateContexts: typeof TranslateContext = TranslateContext;
	
	SHARED__MSG_SUCESS__IMPORT_FILE_OK_REPORT_EMAIL: string = InnerMessage.SHARED__MSG_SUCESS__IMPORT_FILE_OK_REPORT_EMAIL;

	constructor(public innerMessagesService: InnerMessagesService) {
		this.innerMessages = new Map<string, InnerMessage>();
		this.subPushInnerMessageService = this.innerMessagesService.pushInnerMessagesObservable.subscribe(
			inMes => {
				if (!Utilities.isVoid(inMes)) {
					if (Utilities.isVoid(this.innerMessages.get(inMes.id))) {
						inMes.state = 'shown';
						this.innerMessages.set(inMes.id, inMes);
						if (inMes.autoDeleteEnable) {
							this.autoDeleteOldMessage(inMes.id);
						}
						if (this.innerMessages.size > this.MAX_MES) {
							const keys: string[] = Array.from(this.innerMessages.keys());
							this.innerMessages.delete(keys[0]);
						}
					}
					Utilities.scrollUp($);
				}
			});
		this.subRemoveInnerMessageService = this.innerMessagesService.removeInnerMessagesObservable.subscribe(
			key => {
				if (!Utilities.isVoid(key)) {
					if (key === InnerMessage.DELETE_ALL) {
						this.deleteAllMessages();
					} else {
						this.deleteMessage(key);
					}
				}
			});
	}

	ngOnInit() {
		this.getInnerMessagesList();
	}

	ngOnDestroy(): void {
		if (this.subPushInnerMessageService) {
			this.subPushInnerMessageService.unsubscribe();
		}
		if (this.subRemoveInnerMessageService) {
			this.subRemoveInnerMessageService.unsubscribe();
		}
	}

	autoDeleteOldMessage(key: string) {
		setTimeout(() => {
			this.deleteMessage(key);
		}, (this.innerMessages.get(key) ? this.innerMessages.get(key).autoDeleteDelay : InnerMessage.DELAY));
	}

	deleteMessage(key: string) {
		const innMess = this.innerMessages.get(key);
		if (!Utilities.isVoid(innMess)) {
			innMess.state = 'hidden';
			setTimeout(() => {
				innMess.removing = true;
				this.innerMessages.delete(key);
			}, 310);
		}
	}

	getInnerMessagesList(): InnerMessage[] {
		this.innerMessagesValues = Array.from(this.innerMessages.values());

		return this.innerMessagesValues;
	}

	private deleteAllMessages() {
		const keyList = Array.from(this.innerMessages.keys());
		for (let i = 0; i < keyList.length; i++) {
			if (!this.innerMessages.get(keyList[i]).keepAlive) {
				this.deleteMessage(keyList[i]);
			} else {
				this.innerMessages.get(keyList[i]).keepAlive = false;
			}
		}
	}
}
